import { IPublishTerm } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { EPromotionType } from '../../../../types/reducers/publishTerms';

const SERVICE_ORDER = [EPromotionType.Top, EPromotionType.Premium, EPromotionType.Standard];

export function getServices(response: IAddFormPublishTermsResponse): IPublishTerm[] {
  const { terms } = response;

  if (!terms) {
    return [];
  }

  return SERVICE_ORDER.reduce((acc, serviceId) => {
    const term = terms.find(({ promotionType }) => promotionType === serviceId);

    if (term) {
      acc.push(term);
    }

    return acc;
  }, [] as IPublishTerm[]);
}
